import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import Resume from '../download/Luna_Noel.pdf';
import './Navbar.css';

function Navbar() {
    const [click, setClick] = useState(false);
    const[button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false)
        } 
        else {
            setButton(true)
        }
    };

    useEffect(() => {
        showButton();
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <>
            <nav className='navbar'>
                <div className='navbar-container'>
                    <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                        NL
                    </Link>
                    <div className='menu-icon' onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item'>
                            <a href="https://www.linkedin.com/in/noelamadorluna/" className='nav-links' onClick={closeMobileMenu}>LinkedIn</a>
                        </li>
                        <li className='nav-item'>
                            <a href="https://github.com/nluna96" className='nav-links' onClick={closeMobileMenu}>GitHub</a>
                        </li>
                        <li className='nav-item'>
                            <a href={Resume} download="Luna_Noel" className='nav-links-mobile' onClick={closeMobileMenu}>
                                Resume
                            </a>
                        </li>
                    </ul>
                    {button && <Button buttonStyle='btn--outline'>Resume</Button>}
                </div>
            </nav>
        </>
    );
}

export default Navbar;